import * as vuex from 'vuex'
import Actions from '@/constants/action'

export const upload = {
  methods: {
    ...vuex.mapActions({
      upload: Actions.UPLOAD_FILE,
      uploadFileToSys: Actions.UPLOAD_FILE_TO_SYS,
      fetchUrl: Actions.FETCH_FILE_URL
    }),
    async uploadFile(e, dir, isPublic = true) {
      try {
        const name = (e.target && e.target.files[0].name) || e.file.name
        const file = (e.target && e.target.files[0]) || e.file
        return await this.upload({
          isPublic: isPublic,
          dir: `${dir}`,
          name: encodeURI(name),
          file: file
        })
      } catch (err) {
        throw err
      }
    },
    // 存阿里云：循环提交file
    async uploadFiles(file, dir, isPublic = true, allPath) {
      const nameArr = file.name.split('.')
      // alert(encodeURI(nameArr[0] + '-' + new Date().getTime() + '.' + nameArr[nameArr.length - 1]))
      // alert(file.name)
      try {
        return await this.upload({
          isPublic: isPublic,
          dir: `${dir}`,
          name: encodeURI(nameArr[0] + '-' + new Date().getTime() + '.' + nameArr[nameArr.length - 1]),
          allPath,
          file: file
        })
      } catch (err) {
        throw err
      }
    },
    // 存系统
    async uploadToSys(file) {
      try {
        if (!Array.isArray(file)) {
          return await this.uploadFileToSys([file])
        } else {
          return await this.uploadFileToSys(file)
        }
      } catch (error) {
        console.log(error)
      }
    },

    async getFileUrl(name) {
      return await this.fetchUrl(name)
    }

  }
}

